import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const KEY = "agrivoire_cookie_consent";
const CookieConsentContext = createContext(null);

// consent: undefined = loading, null = undecided, "accepted", "rejected"
export const CookieConsentProvider = ({ children }) => {
  const [consent, setConsentState] = useState(undefined);

  useEffect(() => {
    try {
      const v = localStorage.getItem(KEY);
      setConsentState(v === "accepted" || v === "rejected" ? v : null);
    } catch {
      setConsentState(null);
    }
  }, []);

  const setConsent = useCallback((v) => {
    try { localStorage.setItem(KEY, v); } catch {}
    setConsentState(v);
  }, []);

  const accept = useCallback(() => setConsent("accepted"), [setConsent]);
  const reject = useCallback(() => setConsent("rejected"), [setConsent]);
  const reset = useCallback(() => {
    try { localStorage.removeItem(KEY); } catch {}
    setConsentState(null);
  }, []);

  return (
    <CookieConsentContext.Provider value={{ consent, accept, reject, reset }}>
      {children}
    </CookieConsentContext.Provider>
  );
};

export const useCookieConsent = () => useContext(CookieConsentContext);
